const editGroupSet = (state, action) => {
  switch (action.status) {
    case 'success':
    case 'error':
      return {
        ...state,
        editGroupSetDialogOpenFor: null,
      };
    default:
      return state;
  }
};

export default editGroupSet;
